/*  GOLDZENN — Lock Selector
 *
 *  Traditional is the chain's inherent closure. Paid closures, Infinity and
 *  engraving are nested children. Every add receives a private group id so the
 *  exact parent/children can be verified and, if necessary, rolled back safely.
 */
(function () {
  'use strict';

  var TAG = '[GZ-LOCK]';
  function log() {
    try { console.log.apply(console, [TAG].concat([].slice.call(arguments))); } catch (e) {}
  }

  var root = document.querySelector('[data-gz-lock]');
  if (!root) return;

  var form = root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  var addBtn = form ? form.querySelector('[data-product-add]') : document.querySelector('[data-product-add]');
  var stickyBar = root.querySelector('[data-gz-lock-sticky]');
  var stickyBtn = root.querySelector('[data-gz-sticky-add]');
  var stickyBtnText = root.querySelector('[data-gz-sticky-button-text]');
  var stickyClosure = root.querySelector('[data-gz-sticky-closure]');
  var stickyTotal = root.querySelector('[data-gz-sticky-total]');
  var errorEl = root.querySelector('[data-gz-lock-error]');
  var engraveWrap = root.querySelector('[data-gz-engrave]');
  var engraveBox = engraveWrap && engraveWrap.querySelector('input[type="checkbox"]');
  var engraveTxt = engraveWrap && engraveWrap.querySelector('.gz-lock__engrave-text');
  var engraveHint = engraveWrap && engraveWrap.querySelector('[data-gz-engrave-hint]');
  var infinityCard = root.querySelector('[data-lock="infinity"]');
  var diamondNote = root.querySelector('[data-gz-diamond-note]');
  var STYLES = ['sleek', 'lab_diamond', 'natural_diamond'];
  var PICKS = ['traditional', 'infinity'].concat(STYLES);
  var productScope = root.closest('[data-section-product-main]') || document;
  var displayedPrice = productScope.querySelector('[data-product-price]');
  var displayedComparePrice = productScope.querySelector('[data-product-price-compare]');
  var priceBox = displayedPrice && displayedPrice.closest('.product-price');
  var saleBadge = priceBox && priceBox.querySelector('.product-item-banner.on-sale');
  var busy = false;

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (routeRoot.charAt(routeRoot.length - 1) !== '/') routeRoot += '/';
  var routes = {
    add: routeRoot + 'cart/add.js',
    cart: routeRoot + 'cart.js',
    change: routeRoot + 'cart/change.js',
    page: routeRoot + 'cart'
  };

  function showError(msg, focusEl) {
    if (errorEl) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    if (focusEl) {
      focusEl.setAttribute('aria-invalid', 'true');
      focusEl.focus();
    }
    log('BLOCKED:', msg);
  }

  function clearError() {
    if (errorEl) errorEl.hidden = true;
    if (engraveTxt) engraveTxt.removeAttribute('aria-invalid');
  }

  function installFatalGuard(message) {
    function block(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(message);
    }
    if (form) form.addEventListener('submit', block, true);
    if (addBtn) addBtn.addEventListener('click', block, true);
    if (stickyBtn) stickyBtn.addEventListener('click', block, true);
    if (stickyBar) stickyBar.hidden = true;
    showError(message);
    log('FATAL:', message);
  }

  if (!form) {
    installFatalGuard('This product cannot be added right now. Please refresh the page or contact us.');
    return;
  }

  var cfg;
  var priceMap;
  try {
    cfg = JSON.parse(root.dataset.cfg);
    priceMap = JSON.parse(root.dataset.prices);
  } catch (e) {
    installFatalGuard('The closure options could not load. Please refresh the page or contact us.');
    log('bad config', e);
    return;
  }
  /* Traditional is the chain's inherent closure, not a configured variant. */
  if (!cfg || !priceMap) {
    installFatalGuard('The closure options are unavailable. Please refresh the page or contact us.');
    return;
  }

  var isChain = root.dataset.isChain === 'true';
  var currency = root.dataset.currency || 'USD';
  log('init', { isChain: isChain, width: cfg.width, priced: Object.keys(priceMap).length });

  /* ---------- engraving: 1–6 printable ASCII; never mutate input ---------- */
  var ENGRAVE_OK = /^[\x20-\x7E]{1,6}$/;

  function engravingResult() {
    if (!engraveBox || !engraveBox.checked) return { ok: true, value: null };

    var raw = engraveTxt ? engraveTxt.value : '';
    var value = raw.trim();
    if (!value) {
      return { ok: false, msg: 'Enter your engraving, or uncheck engraving.', focus: engraveTxt };
    }
    if (!ENGRAVE_OK.test(value)) {
      return {
        ok: false,
        msg: 'Use 1–6 letters, numbers, spaces, or standard symbols. Emojis and icons aren’t supported.',
        focus: engraveTxt
      };
    }
    return { ok: true, value: value };
  }

  /* ---------- read the selected parent variant ---------- */
  var productJson = null;
  try {
    var holder = document.querySelector('[data-product-json]');
    if (holder) productJson = JSON.parse(holder.dataset.productJson);
  } catch (e) {
    log('note: product JSON was unavailable', e);
  }

  function currentVariant() {
    var el = form.querySelector('select[name="id"], input[name="id"], [name="id"]');
    var vid = el ? el.value : null;
    var variant = null;
    if (productJson && productJson.variants && vid) {
      for (var i = 0; i < productJson.variants.length; i++) {
        if (String(productJson.variants[i].id) === String(vid)) {
          variant = productJson.variants[i];
          break;
        }
      }
    }
    return { id: vid, variant: variant };
  }

  function optionText() {
    var current = currentVariant();
    if (current.variant) {
      if (current.variant.options && current.variant.options.join) return current.variant.options.join(' / ');
      if (current.variant.public_title) return current.variant.public_title;
      if (current.variant.title) return current.variant.title;
    }

    var values = [];
    var selected = form.querySelectorAll('[data-product-swatch-input]:checked, select:not([name="id"]), input[type="radio"]:checked');
    Array.prototype.forEach.call(selected, function (el) {
      if (el.name && el.name.indexOf('gz_') === 0) return;
      if (el.value) values.push(el.value);
    });
    return values.join(' / ');
  }

  function karat() {
    var text = (optionText() || '').toUpperCase();
    if (text.indexOf('18K') > -1) return '18K';
    if (text.indexOf('14K') > -1) return '14K';
    if (text.indexOf('10K') > -1) return '10K';
    return null;
  }

  /* Gold products price by selected karat. Silver products have one metal
   * key (950) supplied by their isolated config, so length changes never hide
   * or misprice a closure. */
  function pricingKey() {
    return karat() || (cfg.pricing_mode === 'single' ? cfg.metal_key : null);
  }

  function lengthInches() {
    var match = (optionText() || '').match(/(\d{2}(?:\.\d)?)\s*["”]/);
    return match ? parseFloat(match[1]) : null;
  }

  function selectedPick() {
    var selected = root.querySelector('input[name="gz_lock"]:checked');
    return selected ? selected.value : 'traditional';
  }

  /* ---------- live price and availability ---------- */
  function liveEntry(id) {
    return id ? priceMap[String(id)] : null;
  }

  function liveCents(id) {
    var entry = liveEntry(id);
    return entry && typeof entry.p === 'number' ? entry.p : null;
  }

  function liveAvailable(id) {
    var entry = liveEntry(id);
    return !!entry && entry.a === true;
  }

  function money(cents) {
    try {
      return '+ ' + new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return '+ $' + (cents / 100).toFixed(2);
    }
  }

  function totalMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function centsFromVariant(value) {
    var cents = Number(value);
    return Number.isFinite(cents) ? cents : null;
  }

  function selectedAddonCents() {
    var pick = selectedPick();
    var addon = 0;

    if (STYLES.indexOf(pick) > -1) {
      var closureId = variantIdFor(pick, pricingKey());
      var closureCents = closureId && liveAvailable(closureId) ? liveCents(closureId) : null;
      if (closureCents !== null) addon += closureCents;
    } else if (pick === 'infinity' && cfg.infinity && liveAvailable(cfg.infinity)) {
      addon += liveCents(cfg.infinity) || 0;
    }

    if (pick !== 'infinity' && engraveBox && engraveBox.checked && cfg.engraving && liveAvailable(cfg.engraving)) {
      addon += liveCents(cfg.engraving) || 0;
    }

    return addon;
  }

  function configuredTotalCents() {
    var variant = currentVariant().variant;
    var baseCents = variant ? centsFromVariant(variant.price) : null;
    return baseCents === null ? null : baseCents + selectedAddonCents();
  }

  function selectedClosureLabel() {
    var pick = selectedPick();
    if (pick === 'traditional') return 'Traditional · Included';
    if (pick === 'infinity') return 'Infinity · No clasp';

    var selected = root.querySelector('input[name="gz_lock"]:checked');
    var card = selected && selected.closest('.gz-lock__card');
    var name = card && card.querySelector('.gz-lock__name');
    return name ? name.textContent.trim() : 'Selected closure';
  }

  /* GZ 2026-09-26: the sticky bar shows the full selection (karat colour · length · closure), not only the closure */
  function gzSelectionLabel() {
    var parts = [];
    try {
      var v = currentVariant().variant;
      var names = (productJson && productJson.options) ? productJson.options.map(function (o) { return String((o && o.name) || o).toLowerCase(); }) : [];
      var vals = v ? (v.options || [v.option1, v.option2, v.option3]) : [];
      var color = '', karat = '', length = '';
      names.forEach(function (n, i) {
        var val = vals[i] ? String(vals[i]) : '';
        if (/colou?r/.test(n)) color = val.replace(/\s*gold$/i, '');
        else if (/material|karat|metal|quilat/.test(n)) { var m = val.match(/(\d{1,2})\s*k\b/i); karat = m ? m[1] + 'K' : val; }
        else if (/length|size|largo|longitud|talla/.test(n)) length = val;
      });
      var metal = [karat, color].filter(Boolean).join(' ');
      if (metal) parts.push(metal);
      if (length) parts.push(length);
    } catch (e) {}
    var pick = selectedPick();
    var map = { traditional: 'Traditional lock', infinity: 'Infinity', sleek: 'Sleek lock', lab_diamond: 'Lab diamond lock', natural_diamond: 'Natural diamond lock' };
    parts.push(map[pick] || selectedClosureLabel());
    return parts.join(' · ');
  }

  function paintStickySummary() {
    if (!stickyBar) return;

    var totalCents = configuredTotalCents();
    var closureLabel = gzSelectionLabel();
    if (stickyClosure) stickyClosure.textContent = closureLabel;
    if (stickyTotal) stickyTotal.textContent = totalCents === null ? 'Select options' : totalMoney(totalCents);
    if (stickyBtn && totalCents !== null) {
      stickyBtn.setAttribute('aria-label', 'Add configured product to cart for ' + totalMoney(totalCents));
    }
  }

  /*
   * Add-ons may increase the displayed selling price, but they are not part of
   * the chain promotion. The compare-at price and OFF badge always describe the
   * parent chain variant only.
   */
  function paintSellingPrice() {
    if (!displayedPrice) return;

    var variant = currentVariant().variant;
    var baseCents = variant ? centsFromVariant(variant.price) : null;
    if (baseCents === null) return;

    var totalCents = configuredTotalCents();
    displayedPrice.textContent = totalMoney(totalCents);
    displayedPrice.setAttribute('aria-live', 'polite');
    displayedPrice.setAttribute('aria-label', 'Price ' + totalMoney(totalCents));

    var compareCents = variant ? centsFromVariant(variant.compare_at_price) : null;
    if (displayedComparePrice) {
      if (compareCents !== null && compareCents > baseCents) {
        displayedComparePrice.textContent = totalMoney(compareCents);
        displayedComparePrice.classList.remove('hidden');

        if (saleBadge) {
          var percent = ((compareCents - baseCents) * 100) / compareCents;
          saleBadge.textContent = Math.round(percent) + '% OFF';
          saleBadge.classList.toggle('hidden', percent <= 0);
        }
      } else {
        displayedComparePrice.classList.add('hidden');
        if (saleBadge) saleBadge.classList.add('hidden');
      }
    }
  }

  function variantIdFor(style, selectedKarat) {
    return cfg[style] && cfg[style][selectedKarat] ? cfg[style][selectedKarat] : null;
  }

  /* ---------- UI state ---------- */
  function selectTraditional() {
    var traditional = root.querySelector('[data-lock="traditional"] input');
    if (traditional) traditional.checked = true;
    paintEngraving();
  }

  function paintPrices() {
    var selectedKarat = pricingKey();
    var anyDiamond = false;

    STYLES.forEach(function (style) {
      var card = root.querySelector('[data-lock="' + style + '"]');
      var output = root.querySelector('[data-price-for="' + style + '"]');
      if (!card || !output) return;

      var input = card.querySelector('input');
      var variantId = selectedKarat ? variantIdFor(style, selectedKarat) : null;
      var cents = variantId ? liveCents(variantId) : null;
      var available = variantId && cents !== null && liveAvailable(variantId);

      card.hidden = !available;
      input.disabled = !available;
      output.textContent = available ? money(cents) : '—';
      if (available && style !== 'sleek') anyDiamond = true;
      if (!available && input.checked) selectTraditional();
    });

    if (diamondNote) diamondNote.hidden = !anyDiamond;

    var engravingPrice = root.querySelector('[data-price-for="engraving"]');
    var engravingAvailable = cfg.engraving && liveCents(cfg.engraving) !== null && liveAvailable(cfg.engraving);
    if (engravingPrice) {
      engravingPrice.textContent = engravingAvailable ? money(liveCents(cfg.engraving)) : 'Unavailable';
    }
    if (engraveBox && !engravingAvailable) engraveBox.disabled = true;
  }

  function paintInfinity() {
    if (!infinityCard) return;
    var length = lengthInches();
    var available = isChain && length !== null && length >= 24 && cfg.infinity && liveAvailable(cfg.infinity);
    var input = infinityCard.querySelector('input');

    infinityCard.hidden = !available;
    input.disabled = !available;
    if (!available && input.checked) selectTraditional();
  }

  function paintEngraving() {
    if (!engraveWrap) return;

    var infinity = selectedPick() === 'infinity';
    engraveWrap.hidden = infinity;

    if (infinity) {
      if (engraveBox) {
        engraveBox.checked = false;
        engraveBox.disabled = true;
      }
      if (engraveTxt) {
        engraveTxt.value = '';
        engraveTxt.hidden = true;
        engraveTxt.disabled = true;
        engraveTxt.removeAttribute('aria-invalid');
      }
      if (engraveHint) engraveHint.hidden = true;
      clearError();
      return;
    }

    var engravingAvailable = cfg.engraving && liveCents(cfg.engraving) !== null && liveAvailable(cfg.engraving);
    if (engraveBox) engraveBox.disabled = !engravingAvailable;
    if (engraveTxt) {
      engraveTxt.hidden = !engraveBox || !engraveBox.checked;
      engraveTxt.disabled = !engraveBox || !engraveBox.checked;
    }
    if (engraveHint) engraveHint.hidden = !engraveBox || !engraveBox.checked;
  }

  function refresh() {
    paintPrices();
    paintInfinity();
    paintEngraving();
    paintSellingPrice();
    paintStickySummary();
    requestStickyUpdate();
    log('state', { pricingKey: pricingKey(), length: lengthInches(), closure: selectedPick() });
  }

  /* ---------- payload ---------- */
  function makeGroupId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'gz-' + window.crypto.randomUUID();
    }
    return 'gz-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function buildItems() {
    var current = currentVariant();
    var parentId = Number(current.id);
    if (!parentId || !Number.isFinite(parentId)) {
      return { error: 'Please choose your chain options first.' };
    }

    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? Number(quantityInput.value) : 1;
    if (!Number.isInteger(quantity) || quantity < 1) {
      return { error: 'Please enter a valid quantity.' };
    }

    /* Resolve closure before reading engraving. Infinity can never carry it. */
    var chosen = root.querySelector('input[name="gz_lock"]:checked');
    var pick = chosen ? chosen.value : 'traditional';
    if (PICKS.indexOf(pick) === -1) return { error: 'Please choose a valid closure.' };

    var selectedKarat = pricingKey();
    var childVariantId = null;
    var closureLabel = 'Traditional Box Lock (included)';

    if (pick === 'infinity') {
      var length = lengthInches();
      if (!isChain || length === null || length < 24 || !cfg.infinity || !liveAvailable(cfg.infinity)) {
        return { error: 'Infinity is only available on eligible chains 24" and longer.' };
      }
      childVariantId = Number(cfg.infinity);
      closureLabel = 'Infinity — no clasp';
    } else if (pick !== 'traditional') {
      childVariantId = Number(variantIdFor(pick, selectedKarat));
      if (!childVariantId || liveCents(childVariantId) === null || !liveAvailable(childVariantId)) {
        return { error: 'That closure is not available for the selected material.' };
      }
      var nameEl = chosen && chosen.closest('.gz-lock__card').querySelector('.gz-lock__name');
      closureLabel = (nameEl ? nameEl.textContent.trim() : pick) + ' — ' +
        (cfg.metal_label || selectedKarat);
    }

    var engraving = { ok: true, value: null };
    if (pick !== 'infinity') {
      engraving = engravingResult();
      if (!engraving.ok) return { error: engraving.msg, focus: engraving.focus };
      if (engraving.value && (!cfg.engraving || !liveAvailable(cfg.engraving))) {
        return { error: 'Engraving is not available right now. Please uncheck engraving.' };
      }
    }

    var groupId = makeGroupId();
    var parentProperties = {
      '_gz_group': groupId,
      '_gz_role': 'parent',
      '_gz_default_closure': 'Traditional Box Lock (included)'
    };
    var items = [{ id: parentId, quantity: quantity, properties: parentProperties }];
    var expected = [{ id: parentId, qty: quantity, role: 'parent', child: false }];

    if (childVariantId) {
      items.push({
        id: childVariantId,
        quantity: quantity,
        parent_id: parentId,
        properties: {
          '_gz_group': groupId,
          '_gz_role': 'closure',
          'Closure': closureLabel
        }
      });
      expected.push({ id: childVariantId, qty: quantity, role: 'closure', child: true });
    }

    if (pick !== 'infinity' && engraving.value) {
      items.push({
        id: Number(cfg.engraving),
        quantity: quantity,
        parent_id: parentId,
        properties: {
          '_gz_group': groupId,
          '_gz_role': 'engraving',
          'Engraving': engraving.value
        }
      });
      expected.push({ id: Number(cfg.engraving), qty: quantity, role: 'engraving', child: true });
    }

    /* Final boundary assertion: an Infinity payload must never contain engraving. */
    if (pick === 'infinity') {
      for (var i = 0; i < items.length; i++) {
        if (items[i].properties && (items[i].properties._gz_role === 'engraving' || items[i].properties.Engraving)) {
          return { error: 'Infinity cannot be combined with engraving.' };
        }
      }
    }

    return { items: items, expected: expected, groupId: groupId, pick: pick };
  }

  /* ---------- exact group verification ---------- */
  function property(line, name) {
    return line && line.properties ? line.properties[name] : null;
  }

  function linesForGroup(cart, groupId) {
    var lines = cart && cart.items ? cart.items : [];
    return lines.filter(function (line) {
      return String(property(line, '_gz_group') || '') === groupId;
    });
  }

  function verifyGroup(cart, built) {
    var problems = [];
    var groupLines = linesForGroup(cart, built.groupId);
    var parents = groupLines.filter(function (line) { return property(line, '_gz_role') === 'parent'; });

    if (groupLines.length !== built.expected.length) {
      problems.push('expected ' + built.expected.length + ' grouped lines, found ' + groupLines.length);
    }
    if (parents.length !== 1) problems.push('expected exactly one grouped parent');

    var parent = parents.length === 1 ? parents[0] : null;
    if (parent && parent.parent_relationship) problems.push('the grouped parent is nested');
    if (parent && !parent.key) problems.push('the grouped parent has no line key');

    var usedKeys = {};
    built.expected.forEach(function (want) {
      var matches = groupLines.filter(function (line) {
        return Number(line.variant_id) === want.id && property(line, '_gz_role') === want.role;
      });

      if (matches.length !== 1) {
        problems.push('expected one ' + want.role + ' line for variant ' + want.id);
        return;
      }

      var line = matches[0];
      if (!line.key || usedKeys[line.key]) problems.push('missing or duplicate line key for ' + want.role);
      if (line.key) usedKeys[line.key] = true;
      if (Number(line.quantity) !== want.qty) problems.push('wrong quantity on ' + want.role);

      if (want.child) {
        var parentKey = line.parent_relationship && line.parent_relationship.parent_key;
        if (!parent || !parentKey || parentKey !== parent.key) {
          problems.push(want.role + ' is not nested under the exact new parent');
        }
      } else if (line.parent_relationship) {
        problems.push('parent unexpectedly has a parent relationship');
      }
    });

    if (built.pick === 'infinity') {
      var engravingLines = groupLines.filter(function (line) {
        return property(line, '_gz_role') === 'engraving' || property(line, 'Engraving');
      });
      if (engravingLines.length) problems.push('Infinity group contains engraving');
    }

    return { ok: problems.length === 0, problems: problems, lines: groupLines, parent: parent };
  }

  function fetchJson(url, options) {
    return fetch(url, options || { credentials: 'same-origin' }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok) {
          var message = body && (body.description || body.message);
          var error = new Error(message || 'Request failed (' + response.status + ').');
          error.status = response.status;
          error.body = body;
          throw error;
        }
        return body;
      });
    });
  }

  function readCart() {
    return fetchJson(routes.cart, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
  }

  function removeLineByKey(key) {
    return fetchJson(routes.change, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function cleanupGroup(groupId, cartSnapshot) {
    var snapshotPromise = cartSnapshot ? Promise.resolve(cartSnapshot) : readCart();
    var hadLines = false;

    return snapshotPromise.then(function (cart) {
      var lines = linesForGroup(cart, groupId);
      hadLines = lines.length > 0;

      /* Remove children first. Removing the parent last also clears any child
       * whose instructions prevented a direct removal. */
      lines.sort(function (a, b) {
        var aParent = property(a, '_gz_role') === 'parent' ? 1 : 0;
        var bParent = property(b, '_gz_role') === 'parent' ? 1 : 0;
        return aParent - bParent;
      });

      var sequence = Promise.resolve();
      lines.forEach(function (line) {
        sequence = sequence.then(function () {
          if (!line.key) return null;
          return removeLineByKey(line.key).catch(function (error) {
            log('cleanup line failed; continuing', line.key, error);
            return null;
          });
        });
      });
      return sequence;
    }).then(function () {
      return readCart();
    }).then(function (cart) {
      return { clean: linesForGroup(cart, groupId).length === 0, hadLines: hadLines, cart: cart };
    });
  }

  /* ---------- add, verify, and rollback if verification fails ---------- */
  function doAdd(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;

    var built;
    try {
      built = buildItems();
    } catch (error) {
      log('payload error', error);
      showError('The closure configuration could not be prepared. Please refresh and try again.');
      return;
    }
    if (built.error) {
      showError(built.error, built.focus);
      return;
    }

    busy = true;
    clearError();
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
    }
    if (stickyBtn) {
      stickyBtn.disabled = true;
      stickyBtn.setAttribute('aria-busy', 'true');
    }
    if (stickyBtnText) stickyBtnText.textContent = 'Adding…';

    function release() {
      busy = false;
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-busy');
      }
      if (stickyBtn) {
        stickyBtn.disabled = !!(addBtn && addBtn.disabled);
        stickyBtn.removeAttribute('aria-busy');
      }
      syncStickyButton();
    }

    function recover(reason, snapshot) {
      log('VERIFY/ADD FAILED:', reason, snapshot || 'no cart snapshot');
      return cleanupGroup(built.groupId, snapshot).then(function (result) {
        release();
        if (result.clean && result.hadLines) {
          showError('We couldn’t verify this configuration, so it was removed from your cart. Please try again.');
        } else if (result.clean) {
          showError('We couldn’t add this configuration. We checked your cart and no items from this attempt remain. Please try again.');
        } else {
          showError('We couldn’t confirm this configuration or remove it completely. Please review your cart before trying again.');
        }
      }).catch(function (cleanupError) {
        log('CLEANUP COULD NOT BE VERIFIED:', cleanupError);
        release();
        showError('We couldn’t confirm this configuration or verify cleanup. Please review your cart before trying again.');
      });
    }

    log('adding group', built.groupId, built.items);
    fetchJson(routes.add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: built.items })
    }).then(function (responseBody) {
      log('cart/add.js response', responseBody);
      return readCart();
    }).then(function (cart) {
      var result = verifyGroup(cart, built);
      if (!result.ok) return recover(result.problems, cart);

      log('verified group', built.groupId, 'parent', result.parent.key);
      window.location.assign(routes.page);
      return null;
    }).catch(function (error) {
      return recover(error && error.message ? error.message : 'Unknown add error', null);
    });
  }

  form.addEventListener('submit', doAdd, true);
  if (addBtn) addBtn.addEventListener('click', doAdd, true);
  if (stickyBtn) stickyBtn.addEventListener('click', doAdd, true);

  /* ---------- events ---------- */
  root.addEventListener('change', function (event) {
    if (event.target.name === 'gz_lock') {
      clearError();
      paintEngraving();
    }
    if (event.target === engraveBox && engraveTxt) {
      engraveTxt.hidden = !engraveBox.checked;
      engraveTxt.disabled = !engraveBox.checked;
      if (engraveHint) engraveHint.hidden = !engraveBox.checked;
      if (engraveBox.checked) {
        engraveTxt.focus();
      } else {
        engraveTxt.value = '';
        clearError();
      }
    }
    paintSellingPrice();
    paintStickySummary();
    requestStickyUpdate();
  });

  if (engraveTxt) {
    engraveTxt.addEventListener('input', function () {
      if (!engraveBox || !engraveBox.checked) return;
      var result = engravingResult();
      if (result.ok || !engraveTxt.value) {
        clearError();
      } else {
        showError(result.msg);
        engraveTxt.setAttribute('aria-invalid', 'true');
      }
    });
  }

  form.addEventListener('change', function (event) {
    if (event.target.name && event.target.name.indexOf('gz_') === 0) return;
    setTimeout(refresh, 0);
  });
  document.addEventListener('variant:change', refresh);

  /* Shared gold/silver financing handoff: preserve selected lock and engraving.
     This is deliberately separate from gold-only production copy and sizing. */
  var financeEs=document.documentElement.lang.indexOf('es')===0;
  function financeExtras(){return selectedPick()!=='traditional'||!!(engraveBox&&engraveBox.checked)}
  document.addEventListener('click',function(e){
    var path=e.composedPath?e.composedPath():[],button=null;
    for(var i=0;i<path.length;i++){var n=path[i];if(n&&n.tagName==='BUTTON'&&!n.getAttribute('aria-label')&&/checkout|ir al pago|pago|pagar|continu/i.test(n.textContent||'')){button=n;break}}
    var shadow=button&&button.getRootNode();
    if(!button||!(shadow instanceof ShadowRoot)||!financeExtras())return;
    var host=shadow.host,terms=host&&host.closest&&host.closest('shopify-payment-terms');
    // Shopify currently renders this dialog through a DIV shadow portal, not
    // just the older custom element. Require the installments dialog content.
    var installments=/sample plans|planes de muestra|shop pay installments/i.test(shadow.textContent||'');
    if(!terms&&host&&host.tagName!=='SHOPIFY-INSTALLMENTS-MODAL'&&!installments)return;
    e.preventDefault();e.stopImmediatePropagation();
    var close=shadow.querySelector('button[aria-label="Close"],button[aria-label="Cerrar"],button[aria-label*="lose"],button[aria-label*="errar"]');
    if(close)close.click();
    setTimeout(function(){if(!addBtn)return;addBtn.scrollIntoView({block:'center'});addBtn.click();setTimeout(function(){if(errorEl&&!errorEl.hidden)errorEl.scrollIntoView({block:'center'})},600)},350);
  },true);
  var finance=document.querySelector('.mak-installments'),financeNote=null;
  function financeDisclosure(){
    if(!finance)return;
    if(!financeNote){financeNote=document.createElement('p');financeNote.className='gz-fin-note';financeNote.style.cssText='margin:0 0 8px;font-size:12px;line-height:1.35;color:#6b6457';financeNote.textContent=financeEs?'Estimado solo de la pieza; las mejoras se suman al pagar.':'Estimate is for the piece only; upgrades are added at checkout.';finance.after(financeNote)}
    financeNote.hidden=!((selectedPick()!=='traditional'&&selectedPick()!=='infinity')||(engraveBox&&engraveBox.checked));
  }
  form.addEventListener('change',function(){setTimeout(financeDisclosure,60)},true);financeDisclosure();

  /* ---------- mobile sticky purchase companion ---------- */
  var stickyFrame = null;
  var engravingHasFocus = false;

  function mobileViewportHeight() {
    return window.visualViewport && window.visualViewport.height
      ? window.visualViewport.height
      : window.innerHeight;
  }

  /* GZ 2026-09-26 rev 4 (Codex review): the fixed/sticky site header can sit on top of the native button. Measure the
     header's bottom edge at the button's x, so a button hidden under the header counts as not visible and the bar stays. */
  function topHeaderBottom(viewportHeight) {
    try {
      var r0 = addBtn.getBoundingClientRect();
      var x = Math.max(2, Math.min(window.innerWidth - 2, r0.left + r0.width / 2));
      var el = document.elementFromPoint(x, 2);
      while (el && el !== document.body && el !== document.documentElement) {
        if (stickyBar && stickyBar.contains(el)) return 0;
        var pos = window.getComputedStyle(el).position;
        if (pos === 'fixed' || pos === 'sticky') {
          var r = el.getBoundingClientRect();
          return (r.top <= 2 && r.bottom > 0 && r.height < viewportHeight * 0.4) ? r.bottom : 0;
        }
        el = el.parentElement;
      }
    } catch (e) {}
    return 0;
  }

  function nativeButtonIsVisible(viewportHeight) {
    if (!addBtn) return false;
    var rect = addBtn.getBoundingClientRect();
    var visibleTop = Math.max(rect.top, topHeaderBottom(viewportHeight));
    var visibleBottom = Math.min(rect.bottom, viewportHeight);
    var visiblePixels = Math.max(0, visibleBottom - visibleTop);
    return visiblePixels >= rect.height * 0.5;
  }

  function syncStickyButton() {
    if (!stickyBtn) return;
    var nativeText = addBtn && addBtn.querySelector('.button-text');
    var label = nativeText && nativeText.textContent.trim() ? nativeText.textContent.trim() : 'Add to Cart';
    var disabled = !addBtn || addBtn.disabled || addBtn.classList.contains('button-disabled') || busy;

    stickyBtn.disabled = disabled;
    stickyBtn.classList.toggle('button-disabled', disabled);
    if (stickyBtnText) stickyBtnText.textContent = busy ? 'Adding…' : label;
  }

  function updateStickyVisibility() {
    stickyFrame = null;
    if (!stickyBar || !addBtn) return;

    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var viewportHeight = mobileViewportHeight();
    var closureRect = root.getBoundingClientRect();
    var closureReached = closureRect.top <= viewportHeight * 0.72;
    /* GZ 2026-09-26 D1: on tablets/desktop the bar appears once the shopper scrolls (the native button is below the fold there) */
    var scrolledDown = (window.pageYOffset || document.documentElement.scrollTop || 0) > 250;
    var shouldShow = (mobile ? closureReached : scrolledDown) && !nativeButtonIsVisible(viewportHeight) && !engravingHasFocus;

    stickyBar.classList.toggle('is-visible', shouldShow);
    stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    if (shouldShow) document.body.style.setProperty('--gz-purchase-bar-height', Math.ceil(stickyBar.getBoundingClientRect().height) + 'px');
  }

  function requestStickyUpdate() {
    if (!stickyBar || stickyFrame !== null) return;
    stickyFrame = window.requestAnimationFrame(updateStickyVisibility);
  }

  function initializeSticky() {
    if (!stickyBar || !stickyBtn || !addBtn) return;
    stickyBar.hidden = false;
    /* GZ 2026-09-26: inside the sticky product column the bar was painted under later sections (a tap could
       open another listing). Move it to <body>; listeners stay attached and it still runs the same doAdd(). */
    if (stickyBar.parentNode !== document.body) document.body.appendChild(stickyBar);
    syncStickyButton();
    paintStickySummary();

    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', requestStickyUpdate, { passive: true });
      window.visualViewport.addEventListener('scroll', requestStickyUpdate, { passive: true });
    }

    if (engraveTxt) {
      engraveTxt.addEventListener('focus', function () {
        engravingHasFocus = true;
        requestStickyUpdate();
      });
      engraveTxt.addEventListener('blur', function () {
        engravingHasFocus = false;
        window.setTimeout(requestStickyUpdate, 120);
      });
    }

    if (window.MutationObserver) {
      new MutationObserver(function () {
        syncStickyButton();
        requestStickyUpdate();
      }).observe(addBtn, { attributes: true, childList: true, subtree: true });
    }

    requestStickyUpdate();
  }

  refresh();
  initializeSticky();
})();
